import { createStyles, makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";

export const ArrowTopMenu = styled.div`
  background-color: #fff;
  position: absolute;
  left: 2.9rem;
  margin: 1rem 0 0 0;
  width: 18px;
  height: 18px;
  border-radius: 3px;
  transform: translateX(-50%) rotate(-45deg);
  z-index: 1;
  border: solid 0.5px;
  border-right-color: rgba(0, 0, 0, 0.2);
  border-top-color: rgba(0, 0, 0, 0.2);
  border-left-color: #fff;
  border-bottom-color: #fff;
  @media only screen and (max-width: 65rem) {
    display: none;
  }
`;

export const PopUp = styled.span`
  background-color: #fff;
  border-radius: 16px;
  width: 420px;
  position: absolute;
  right: -20px;
  &:after {
    content: " ";
    position: absolute;
    left: 353px;
    top: -10px;
    border-left: 25px solid transparent;
    border-right: 25px solid transparent;
    border-bottom: 25px solid #fff;
  }
  &.dismiss {
    display: none;
    animation: fadeOut 1s;
  }

  &.popup {
    display: block;
    animation: fadeIn 1s;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;

export const MenuItem = styled.li`
  height: 100%;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
`;
export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "flex",
      justifyContent: "space-evenly",
      height: "100%",
      width: "100%",
    },
    items: {
      display: "flex",
      paddingTop: "5px",
      color: "#399ebf",
      fontSize: "15px",
      fontWeight: "bold",
      width: "7rem",
      justifyContent: "space-between",
      alignItems: "center",
    },
    tab: {
      textTransform: "none",
    },
    divContainerMenu: {
      fontSize: 11,
      display: "flex",
      textTransform: "capitalize",
      height: "100%",
      position: "relative",
      width: "103px",
    },
    divContainerDropdown: {
      position: "absolute",
      top: "24px",
      boxShadow: "0 1rem 2rem rgba(0, 0, 0, 0.1)",
      backgroundColor: "#fff",
      borderBottomLeftRadius: "5px",
      borderBottomRightRadius: "5px",
    },
    divContainerDropdownLC: {
      position: "absolute",
      top: "24px",
      boxShadow: "0 1rem 2rem rgba(0, 0, 0, 0.1)",
      backgroundColor: "#fff",
      borderBottomLeftRadius: "5px",
      borderBottomRightRadius: "5px",
      left: "-40px",
    },
    divContainerUl: {
      padding: "10px",
    },

    ulStyled: {
      listStyle: "none",
      paddingTop: "0px",
      display: "inline-flex",
      justifyContent: "space-evenly",
      margin: 0,
      width: "30em",
      "@media(max-width: 1215px)": {
        width: "23em",
      },
    },
    ulDopdownStyled: {
      listStyle: "none",
      display: "contents",
      "& >li": {
        padding: "7px 13px 7px 13px",
        borderBottom: "solid 1px",
        borderBottomColor: "#7878781c",
        cursor: "pointer",
      },
    },
    fildelyMenu: {
      width: "170px",
    },
    menuItem: {
      paddingRight: "20px",
    },
    navContentMenu: {
      display: "inline-flex",
      cursor: "pointer",
      margin: "auto",
    },
    activeText: {
      color: "#38c0ea",
      margin: "3px",
    },
    inActiveText: {
      color: "#70748f",
      margin: "3px",
    },
    itemsFedelity: {
      height: "8rem",
      width: "8rem",
      position: "absolute",
      top: "40px",
    },
    itemsCash: {
      height: "7rem",
      width: "8rem",
      position: "absolute",
      top: "40px",
    },
    itemsTracking: {
      height: "8rem",
      width: "8rem",
      position: "absolute",
      top: "40px",
    },
  })
);
